(function () {
  var loaded = false;

  function loadClarity() {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "z8dtmn992g");
    loaded = true;
  }

  function applyConsent(analytics, marketing) {
    if (analytics && !loaded) loadClarity();
    if (loaded) {
      window.clarity('consentv2', {
        ad_Storage: marketing ? "granted" : "denied",
        analytics_Storage: analytics ? "granted" : "denied"
      });
    }
  }

  window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
    if (error) return;
    var cp = window.Shopify.customerPrivacy;
    applyConsent(cp.analyticsProcessingAllowed(), cp.marketingAllowed());
  });

  document.addEventListener("visitorConsentCollected", function (e) {
    applyConsent(e.detail.analyticsAllowed, e.detail.marketingAllowed);
  });
})();
